<template>
  <a-config-provider>
    <template #renderEmpty>
      <a-empty description="Brak materiałów dydaktycznych" />
    </template>
    <a-list
      class="list"
      :loading="loading"
      itemLayout="horizontal"
      :pagination="pagination"
      :dataSource="results"
    >
      <a-list-item slot="renderItem" slot-scope="item" class="list-item">
        <a-list-item-meta>
          <div slot="title">
            <h4>{{ item.name }}</h4>

            <a-tooltip
              slot="datetime"
              :title="momentize(item.created).format('YYYY-MM-DD HH:mm:ss')"
            >
              <span class="add-date">
                {{ momentize(item.created).fromNow() }} przez
                <a-icon type="user" /> {{ item.author_name }}
              </span>
            </a-tooltip>

            <p class="link-label t-secondary-text">Link źródłowy</p>
            <a :href="item.url" target="_blank" class="link t-text">
              {{ item.url }}
            </a>
          </div>
        </a-list-item-meta>

        <a slot="actions" :disabled="readOnly || !isAuthorOrAdmin(item)">
          <a-button
            :disabled="readOnly || !isAuthorOrAdmin(item)"
            type="link"
            icon="edit"
            @click="editInstance(item.id)"
          />
        </a>
        <a slot="actions" :disabled="readOnly || !isAuthorOrAdmin(item)">
          <a-button
            :disabled="readOnly || !isAuthorOrAdmin(item)"
            class="c-remove-button"
            type="link"
            icon="delete"
            @click="deleteInstance(item.id)"
          />
        </a>
      </a-list-item>
    </a-list>
  </a-config-provider>
</template>

<script>
export default {
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isAuthorOrAdmin(instance) {
      return this.isAdmin || this.userInfo.id === instance.author
    },
    editInstance(instanceId) {
      this.$emit('editInstance', { instanceId })
    },
    deleteInstance(instanceId) {
      this.$emit('deleteInstance', instanceId)
    }
  }
}
</script>
<style lang="scss" scoped>
.link-label {
  font-size: 14px;
  margin: 16px 0 0;
}

.add-date {
  font-size: 12px;
  color: #a9a9a9;

  position: absolute;
  top: 18px;
  right: 16px;
}

.list-item {
  position: relative;
  align-items: flex-end;
}
</style>
